export default "__VITE_ASSET__06f4215a__"